

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import './UserDetail.css';

const UserDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setUser({
        id: id,
        name: 'Captain John Smith',
        email: 'john.smith@orientshipping.com',
        role: 'owner',
        status: 'active',
        company: 'Orient Shipping',
        phone: '+971 50 123 4567',
        location: 'Dubai, UAE',
        joinedDate: '2024-01-15',
        lastActive: '2024-03-15',
        vessels: ['MV Ocean Star', 'MT Gulf Spirit'],
        jobsPosted: 12,
        jobsCompleted: 8,
        totalSpent: 284500,
        recentActivity: [
          { id: 1, action: 'Posted a new job', entity: 'GMDSS Survey for MV Ocean Star', time: '2024-03-14' },
          { id: 2, action: 'Accepted a quote', entity: 'From MarineTech Solutions', time: '2024-03-12' },
          { id: 3, action: 'Released payment', entity: '$12,500 to MarineTech Solutions', time: '2024-03-10' },
          { id: 4, action: 'Registered new vessel', entity: 'CS Atlantic', time: '2024-03-05' }
        ]
      });
      setLoading(false);
    }, 500);
  }, [id]);

  const handleSuspend = () => {
    if (window.confirm(`Are you sure you want to suspend ${user?.name}?`)) {
      alert('User suspended');
    }
  };

  const handleActivate = () => {
    alert('User activated');
  };

  if (loading) return <div className="loading-spinner">Loading user details...</div>;

  return (
    <div className="admin-user-detail">
      <button className="back-btn" onClick={() => navigate('/admin/users')}>
        <i className="fas fa-arrow-left"></i> Back to Users
      </button>

      <div className="user-header-card">
        <div className="user-header">
          <div className="user-avatar">
            {user.name.charAt(0)}
          </div>
          <div className="user-info">
            <h1>
              {user.name}
              <span className={`role-badge ${user.role}`}>
                {user.role === 'owner' ? 'Ship Owner' : user.role === 'vendor' ? 'Service Provider' : 'Admin'}
              </span>
              <span className={`status-badge ${user.status}`}>
                {user.status}
              </span>
            </h1>
            <div className="user-meta">
              <div className="meta-item">
                <span className="meta-label">Email</span>
                <span className="meta-value">{user.email}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Phone</span>
                <span className="meta-value">{user.phone}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Member Since</span>
                <span className="meta-value">{user.joinedDate}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Last Active</span>
                <span className="meta-value">{user.lastActive}</span>
              </div>
            </div>
            <div className="action-buttons">
              {user.status === 'active' ? (
                <Button variant="danger" onClick={handleSuspend} icon="fa-ban">
                  Suspend User
                </Button>
              ) : (
                <Button variant="primary" onClick={handleActivate} icon="fa-check">
                  Activate User
                </Button>
              )}
              <Button variant="secondary" icon="fa-envelope">
                Send Message
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="profile-section">
        <h3><i className="fas fa-building"></i> Company Information</h3>
        <div className="info-grid">
          <div className="info-item">
            <span className="info-label">Company Name</span>
            <span className="info-value">{user.company}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Location</span>
            <span className="info-value">{user.location}</span>
          </div>
        </div>
      </div>

      {user.role === 'owner' && (
        <div className="profile-section">
          <h3><i className="fas fa-ship"></i> Fleet Information</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Vessels</span>
              <span className="info-value">{user.vessels.join(', ')}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Jobs Posted</span>
              <span className="info-value">{user.jobsPosted}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Jobs Completed</span>
              <span className="info-value">{user.jobsCompleted}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Total Spent</span>
              <span className="info-value">${user.totalSpent.toLocaleString()}</span>
            </div>
          </div>
        </div>
      )}

      <div className="profile-section">
        <h3><i className="fas fa-history"></i> Recent Activity</h3>
        <div className="activity-list">
          {user.recentActivity.map(activity => (
            <div key={activity.id} className="activity-item">
              <div className="activity-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="activity-details">
                <div className="activity-action">{activity.action}</div>
                <div className="activity-entity">{activity.entity}</div>
              </div>
              <div className="activity-time">{activity.time}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
